module.exports = __webpack_public_path__ + "media/country_flags/ml-782c81c4.png";